function add_establishment() {
    var $ = jQuery.noConflict();

    $.squdeAjaxPopup({
        url: '/settings/establishment/add',
        onOpen: function (elm, popup) {
            elm.find('form').ajaxFormSubmit(function(data){
                if(data != "max_reached") {
                    reload_location_if_needed();
                }
            }.bind([elm,popup]), function(xhr, status, error) {
                $('body').doneLoading();
                squde_flash("Er ging iets mis bij het opslaan","alert");
            }.bind([elm,popup]),function() {
                $('body').isLoading('dark');
            });
        }
    });
    return false;
}
function delete_establishment(id, name) {
    var $ = jQuery.noConflict();
    name = decodeURI(name);

    confirm("Weet u zeker dat u \""+name+"\" wilt verwijderen?", function() {
        $('body').isLoading('dark');
        $.ajax({
            url: "/settings/establishment/delete",
            data: {id:id},
            type: "POST",
            success: function(data) {
                $('[data-object-type=\'establishment\'][data-id=\''+id+'\'').remove();
                $('body').doneLoading();
            },
            error: function(e) {
                $('body').doneLoading();
                squde_flash("Er ging helaas iets mis.", "alert");
            }
        });
    });
    return false;
}
//jQuery(document).ready(function() {
//    view_establishment(1);
//});
function view_establishment(id, vars) {
    var $ = jQuery.noConflict();

    if(vars != undefined && typeof vars == "function") {
        vars = {callback: vars};
    }

    $.squdeAjaxPopup({
        url: '/settings/establishment/view/'+id,
        onOpen: function(elm, popup) {
            elm.find('form').ajaxFormSubmit(function(data){
                if(vars == undefined || vars.callback == undefined) {
                    reload_location_if_needed();
                } else {
                    $('body').doneLoading();
                    vars.callback(data, elm, popup);
                }
            }.bind([elm,popup]), function(xhr, status, error) {
                $('body').doneLoading();
                squde_flash("Er ging iets mis bij het opslaan.", "alert");
            }.bind([elm,popup]),function() {
                $('body').isLoading('dark');
            });
        }
    });
    return false;
}